﻿import motivUi from "motivUi";

function onPageUpdated(parentSelector) {
    motivUi.setup
        .inputFormatting()
        .timeAt(parentSelector)
        .dateInput()
        .increment(parentSelector)
        .vehicleLookup((reg) => `/VehicleLookup/${reg}/partial`)
        .addressLookup(parentSelector, motivUi.globals.loqateKey)
        .visibleWhen(parentSelector)
        .select();
}

export default onPageUpdated;